import { useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'

import { getInventoryLocationsByStore } from './helpers'
import { transformResponseMerchantInventoryLocations } from './transformers'

const useMerchantInventoryLocations = () => {
  const { data, loading: fetchingInventoryLocations } = useFetch(commonServices.getMerchantInventoryLocations, {
    doInitialRequest: true,
    transformResponse: transformResponseMerchantInventoryLocations,
  })

  return {
    inventoryLocationsByStore: getInventoryLocationsByStore(data),
    fetchingInventoryLocations,
  }
}

export default useMerchantInventoryLocations
